import { MutationTree } from 'vuex';
import { IRelay, IRelaysViewState } from './types';
import Vue from 'vue';
import _ from 'lodash';

export const mutations: MutationTree<IRelaysViewState> = {
    loaded(state, args: { deviceNumber: string, relays: IRelay[] }) {
        const clonedRelays = _.cloneDeep(args.relays);
        Vue.set(state.device, args.deviceNumber, clonedRelays);
    },
    setName(state, args: {deviceNumber: string, relayNumber: number, name: string}) {
        const relays = state.device[args.deviceNumber];
        if (relays) {
            const relay = relays.find((r) => r.no === args.relayNumber);
            if (relay) {
                Vue.set(relay, 'friendlyName', args.name);
            }
        }
    },
    setMode(state, args: {deviceNumber: string, relayNumber: number, mode: string}) {
        const relays = state.device[args.deviceNumber];
        if (relays) {
            const relay = relays.find((r) => r.no === args.relayNumber);
            if (relay) {
                Vue.set(relay, 'mode', args.mode);
            }
        }
    },
    setIcon(state, args: {deviceNumber: string, relayNumber: number, icon: string}) {
        const relays = state.device[args.deviceNumber];
        if (relays) {
            const relay = relays.find((r) => r.no === args.relayNumber);
            if (relay) {
                Vue.set(relay, 'icon', args.icon);
            }
        }
    },
};
